import { FormsModule } from '@angular/forms';
import { AdminI18nComponent } from '@app/admin/i18n/admin-i18n.component';
import { AdminSettingsComponent } from '@app/admin/settings/admin-settings.component';
import { AdminStammdatenDeaktivierungsgrundComponent } from '@app/admin/stammdaten/deaktivierungsgrund/admin-stammdaten-deaktivierungsgrund.component';
import { AdminStammdatenImportgrundComponent } from '@app/admin/stammdaten/importgrund/admin-stammdaten-importgrund.component';
import { AdminStammdatenLandComponent } from '@app/admin/stammdaten/land/admin-stammdaten-land.component';
import { AdminStammdatenTemplateComponent } from '@app/admin/stammdaten/template/admin-stammdaten-template.component';
import { TabComponent } from '@app/shared/tabs/tab.component';
import { TranslatePipe } from '@ngx-translate/core';
import packageJson from '../../../package.json';
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { downloadFile } from '@app/shared/download-utils';
import { BackendService } from '@app/shared/services/backend.service';
import { TabChangeEvent, TabsComponent } from '@app/shared/tabs/tabs.component';
import { rxResource } from "@angular/core/rxjs-interop";
import { map } from "rxjs/operators";

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  imports: [
    AdminI18nComponent,
    AdminSettingsComponent,
    AdminStammdatenDeaktivierungsgrundComponent,
    AdminStammdatenImportgrundComponent,
    AdminStammdatenLandComponent,
    AdminStammdatenTemplateComponent,
    FormsModule,
    TabComponent,
    TabsComponent,
    TranslatePipe,
  ],
})
export class AdminComponent {
  private readonly backendService = inject(BackendService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  protected readonly frontendVersion = packageJson.version;
  protected readonly backendVersion = rxResource<string, void>({
    defaultValue: '-',
    stream: () => this.backendService.getVersion()
      .pipe(map(result => /^\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(result) ? result : 'N/A'))
  });
  protected readonly currentCategory = rxResource<string, void>({
    defaultValue: '',
    stream: () => this.route.params.pipe(map(params => params.category ?? 'job'))
  });

  protected selectedLogPeriod : number = 1;

  getLogFile() {
    const days = this.selectedLogPeriod;
    this.backendService.getLog(days)
      .subscribe({
        next: downloadFile,
        error: console.error
      });
  }

  onCategoryChange(event: TabChangeEvent) {
    this.router.navigate(['/admin', event.tabId], { queryParamsHandling: 'preserve' });
  }
}
